import { UIUtils } from "../../../../Global/Dom/UIUtils";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";

export class CopyUrlBuilder implements IContentBuilder {
    private static readonly _blockClass = "copy-url-dialog";

    private readonly _options: { url: string; titleLocKey: string }[];

    /**
     * Vytvoří obsah dialogu pro vykopírování odkazů na soubory (originální dokument a archivní verze)
     * @param options Možnosti výběru
     */
    constructor(options: { url: string; titleLocKey: string }[]) {
        this._options = options;
    }

    public async build(): Promise<HTMLElement> {
        const container = createElement({ classes: CopyUrlBuilder._blockClass });
        const buttons: HTMLButtonElement[] = [];
        for (const o of this._options) {
            const option = createElement({ classes: `${CopyUrlBuilder._blockClass}__option` }); //'

            const title = createElement({ classes: `${CopyUrlBuilder._blockClass}__title` }); //'
            Localization.addLocData(title, o.titleLocKey, Localization.TEXT_CONTENT);

            const url = createElement({ classes: `${CopyUrlBuilder._blockClass}__url` }); //'
            url.innerText = o.url;

            const button = createElement({ type: "button", classes: ["btn", "btn-large", `${CopyUrlBuilder._blockClass}__copy-button`] }) as HTMLButtonElement;
            Localization.addLocData(button, "GUI-667875", Localization.TEXT_CONTENT); // Kopírovat "GUI-667875"

            button.addEventListener("click", (_ev: MouseEvent) => {
                if (button.classList.contains("Disabled")) {
                    return;
                }
                UIUtils.pasteToClipboard(o.url);
            });
            buttons.push(button);

            const containerUrlAndCopyBtn = createElement({ classes: `${CopyUrlBuilder._blockClass}__container-url-copy-button` }); //'
            containerUrlAndCopyBtn.appendChild(url);
            containerUrlAndCopyBtn.appendChild(button);

            option.appendChild(title);
            option.appendChild(containerUrlAndCopyBtn);
            container.appendChild(option);
        }
        return container;
    }
}
